import { render, staticRenderFns } from "./newvolumeset.vue?vue&type=template&id=5bc3f7e0&scoped=true&"
import script from "./newvolumeset.vue?vue&type=script&lang=js&"
export * from "./newvolumeset.vue?vue&type=script&lang=js&"
import style0 from "./newvolumeset.vue?vue&type=style&index=0&id=5bc3f7e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3f7e0",
  null
  
)

export default component.exports